/* eslint-disable react/prop-types */
import React from "react";
import { Row, Col } from "react-bootstrap";
// Common
import ClassCapacityWarning from "../../common/ClassCapacityWarning";
import FadeIn from "../../common/FadeIn";
import ReturnButton from "../../common/ReturnButton";
//TimeRendering
import Moment from "react-moment";

const ClassInfo = (props) => {
  const currencySymbol = props.currencySymbol;
  const classData = props.classData;
  const prorationPrice = props.prorationPrice;
  return (
    <FadeIn delay={250} duration={450}>
      <Row>
        <Col>
          <ReturnButton direction={props.direction} />
          <div className='shadow mt-4 p-3 border'>
            <h1>{classData.LessonType}</h1>
            <ClassCapacityWarning
              SubscribersNumber={classData.Subscribers_Number}
              Capacity={classData.MaxLearners}
            />

            <h4>{currencySymbol + parseFloat(classData.Price).toFixed(2) + " / per month"}</h4>
            {classData.Prorate && !classData.monthStartBilling && prorationPrice !== "" ? (
              <small>
                {" "}
                <h6>
                  immediate payment of {currencySymbol + prorationPrice} to cover the sessions in
                  your first month.
                </h6>
              </small>
            ) : (
              ""
            )}
            <hr />
            <p>
              <em>{classData.ShortDescription}</em>
            </p>
            <hr />
            <p>
              These sessions will be held: {classData.Day} between {classData.StartTime} -{" "}
              {classData.FinishTime}.
            </p>
            <hr />
            <p>
              The intended age group is:{" "}
              {classData.LowerAgeString + " - " + classData.UpperAgeString + "."}
            </p>
            <hr />
            {classData.Tutor !== undefined && (
              <>
                <p>The tutor is: {classData.Tutor.First_Name}</p>
                <hr />
              </>
            )}
            <p>
              The session will be held at: {classData.Venue.VenueName},{" "}
              {classData.Venue.VenueAddress}
            </p>
            {classData.Venue.Note && (
              <>
                {" "}
                <hr />
                <p>Venue Note: {classData.Venue.Note}</p>
              </>
            )}
            <hr />
            <p>
              <strong>
                {classData.nextDate ? (
                  <span>The next session date will be {classData.nextDate} (excluding breaks/holidays)</span>) : (
                  <span>Start Date:{" "}
                    <Moment format='ddd DD MMMM YYYY'>{classData.StartDate}</Moment></span>
                )
                }
              </strong>
            </p>

          </div>
        </Col>
      </Row>
    </FadeIn>
  );
};

export default ClassInfo;
